var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"write-off-option-list"},_vm._l((_vm.writeOffOptionList),function(option,index){return _c('div',{key:`write_off_option_${index}`,staticClass:"write-off-option",class:{ 'selected': option.selected },on:{"click":function($event){return _vm.onSelect(option)}}},[_vm._v("\n    "+_vm._s(_vm.$t(option.description))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }